import Vue from 'vue'
import configs from '@/config'
import { readSessionCookie } from '@/services/unleash'

// AHA-42054 — read the shared pricing lineup from general-api. This is the same
// endpoint the pricing page renders from: it resolves the active Unleash variant
// server-side from request-geo (CloudFront-Viewer-Country) + the shared
// `aha_unleash_session` anchor, so the presenter lands on the SAME variant as the
// pricing page WITHOUT needing the viewer's country on the client.
//
// We forward the session id explicitly via `x-unleash-session` (read from the
// shared root-domain cookie) so bucketing is stable even when the cross-subdomain
// cookie is not sent with the cross-origin request. When the cookie is absent the
// endpoint mints + Set-Cookie's one, matching the pricing page's first-visit flow.
const LINEUP_URL = `${configs.baseUrl}/api/pricing/lineup`

const getPricingLineupProducts = async () => {
  const sessionId = readSessionCookie()
  const headers = sessionId ? { 'x-unleash-session': sessionId } : {}
  const res = await Vue.http.get(LINEUP_URL, { headers })
  return res.body?.products || []
}

export default {
  getPricingLineupProducts,
}
